//夜勤(2直)対応の定数。要件 R1/R2、仕様 01-frontend.md §1 に対応。

//夜勤判定の閾値(分)。開始時刻がこの値以上なら夜勤と自動判定する。
//規則上の夜勤開始は15:00だが、将来12:00まで早まる可能性があるため12:00で判定する。
export const NIGHT_SHIFT_THRESHOLD_MIN = 12 * 60; // 720

//夜勤の既定開始時刻(timeListの値)。新規入力(その日その作業者の保存済日報が0件)で
//夜勤トグルをONにしたときに開始時刻へ自動セットする。判定の閾値(12:00)とは別概念で、
//規則上の夜勤開始である15:00を採用する。
export const NIGHT_SHIFT_DEFAULT_START = '15:00';

//勤務区分
export const SHIFT_TYPE_NORMAL = 0;
export const SHIFT_TYPE_NIGHT = 1;

//勤務区分ごとの休憩窓(分)。窓リスト形式(将来の窓追加・時刻変更に対応)。
//通常=12:00–13:00、夜勤=19:00–20:00。窓内の時間は作業時間としてカウントしない。
export const BREAK_WINDOWS: Record<number, Array<[number, number]>> = {
  [SHIFT_TYPE_NORMAL]: [[12 * 60, 13 * 60]], // 12:00–13:00
  [SHIFT_TYPE_NIGHT]: [[19 * 60, 20 * 60]], // 19:00–20:00
};

//1日の上限(分)。チェーン終端が開始からこれを超えると送信不可(F5-1)。
export const MAX_CHAIN_MINUTES = 24 * 60; // 1440
